module.exports = __webpack_public_path__ + "img/e-class2021_930x620.51bb5a9d.png";